// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BarDesktop_logout__HgmD3 {\n  margin-right: -12px;\n}\n.BarDesktop_hamburger__10rmf {\n  margin-right: 12px;\n}\n.BarDesktop_notifications__3M1pV {\n  margin-left: -12px;\n}\n.BarDesktop_compte__ag5KY {\n  margin-left: 0px;\n  margin-right: 12px;\n}\n", "",{"version":3,"sources":["webpack://src/Navigation/Bar/BarDesktop.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".logout {\n  margin-right: -12px;\n}\n.hamburger {\n  margin-right: 12px;\n}\n.notifications {\n  margin-left: -12px;\n}\n.compte {\n  margin-left: 0px;\n  margin-right: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logout": "BarDesktop_logout__HgmD3",
	"hamburger": "BarDesktop_hamburger__10rmf",
	"notifications": "BarDesktop_notifications__3M1pV",
	"compte": "BarDesktop_compte__ag5KY"
};
export default ___CSS_LOADER_EXPORT___;
